require("dotenv").config();

const config = require(`../app-config/app-config-${process.env.REACT_APP_ENV}`).default;

const appConfig = { baseUrl: config.baseUrl };

export default appConfig;
